<template>
    <div class="Order">
        <!-- 搜索栏 -->
        <div class="Search" v-if="i == 2 && project_is_review">
            <el-input class="SearchWid" size="medium" placeholder="项目名称" v-model="xiangMuSearch.name"></el-input>
            <el-select class="SearchWid" size="medium" placeholder="审核状态" v-model="xiangMuSearch.state">
                <el-option label="全部" value="0"></el-option>
                <el-option label="已审核" value="1"></el-option>
                <el-option label="未审核" value="2"></el-option>
            </el-select>
            <el-button class="ColorBlue" size="medium" @click="Query('InstitutionalProjectReview')">查询</el-button>
        </div>
        <div class="Search" v-if="i == 1 && professional_is_review">
            <el-input class="SearchWid" size="medium" placeholder="姓名" v-model="renYuanSearch.name"></el-input>
            <el-input class="SearchWid" size="medium" placeholder="电话" v-model="renYuanSearch.mobile"></el-input>
            <el-select class="SearchWid" size="medium" placeholder="审核状态" v-model="renYuanSearch.state">
                <el-option label="全部" value="0"></el-option>
                <el-option label="已审核" value="1"></el-option>
                <el-option label="未审核" value="2"></el-option>
            </el-select>
            <el-button class="ColorBlue" size="medium" @click="Query('ProfessionalReview')">查询</el-button>
        </div>
        <div class="Search" v-if="i == 3 && company_is_review">
            <el-input class="SearchWid" size="medium" placeholder="机构名称" v-model="jsGouSearch.name"></el-input>
            <el-input class="SearchWid" size="medium" placeholder="机构法人" v-model="jsGouSearch.legal_person"></el-input>
            <el-select class="SearchWid" size="medium" placeholder="审核状态" v-model="jsGouSearch.state">
                <el-option label="全部" value="0"></el-option>
                <el-option label="已审核" value="1"></el-option>
                <el-option label="未审核" value="2"></el-option>
            </el-select>
            <el-button class="ColorBlue" size="medium" @click="Query('ProfessionalOrganizationReview')">查询</el-button>
        </div>

        <!-- 导航栏 -->
        <div class="OrderTop">
            <div class="Nav">
                
                <div class="NavItem" v-if="professional_is_review" :class="{ Act: i == 1 }" @click="ToggleNav(1)">专业人员评审</div>
                <div class="NavItem" v-if="company_is_review" :class="{ Act: i == 2 }" @click="ToggleNav(2)">专业机构评审</div>
                <div class="NavItem" v-if="project_is_review" :class="{ Act: i == 3 }" @click="ToggleNav(3)">机构项目评审</div>
            </div>
        </div>

        <!-- 评审组件 -->
        <InstitutionalProjectReview ref="InstitutionalProjectReview" :SearchInfo="xiangMuSearch" v-if="i === 3 && project_is_review" />
        <ProfessionalReview ref="ProfessionalReview" :SearchInfo="renYuanSearch" v-if="i === 1 && professional_is_review" />
        <ProfessionalOrganizationReview ref="ProfessionalOrganizationReview" :SearchInfo="jsGouSearch" v-if="i === 2 && company_is_review" />

        <!-- 弹窗 -->
        <el-dialog :visible.sync="ReviewBlon" width="50%" :show-close="false" @close="LockBlon = false">
            <div class="CommDig">
                <div>
                    <div class="DigItem">
                        <div class="DigTit">标题</div>
                        <div>{{ SetData.title }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">简介</div>
                        <div>{{ SetData.synopsis }}</div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">图片</div>
                        <div>
                            <img class="LockImg" :src="$Global.CommImgHttp + SetData.img" alt=""
                                @click="OpenLock(SetData.img)">
                        </div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">内容</div>
                        <div v-html="SetData.conten"></div>
                    </div>
                    <div class="DigItem">
                        <div class="DigTit">状态</div>
                        <div>
                            <el-radio-group v-model="SetData.state" disabled size="small">
                                <el-radio :label="1">审核通过</el-radio>
                                <el-radio :label="2">审核驳回</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="DigBtns">
                        <div class="Btn" @click="ReviewBlon = false, SetData = {}">取消</div>
                        <div class="Btn Blue" @click="ReviewSuc">提交</div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ProfessionalReview from '@/components/user/ReviewComponents/ProfessionalReview';
import ProfessionalOrganizationReview from '@/components/user/ReviewComponents/ProfessionalOrganizationReview';
import InstitutionalProjectReview from '@/components/user/ReviewComponents/InstitutionalProjectReview';

export default {
    components: {
        ProfessionalReview,
        ProfessionalOrganizationReview,
        InstitutionalProjectReview,
    },
    data() {
        return {
            i: 1, // 默认显示第一个评审类型
            professional_is_review: false, // 是否拥有审核个人的权限
            company_is_review: false, // 是否拥有审核机构的权限
            project_is_review: false, // 是否拥有审核项目的权限
            Search: {
                title: "",
                cont: "",
                state: "",
            },
            renYuanSearch: {
                name: '',
                mobile: '',
                state: '',
            },
            jsGouSearch: {
                name: '',
                legal_person: '',
                state: '',
            },
            xiangMuSearch: {
                name: '',
                state: '',
            },
            tableData: [],
            total: 0,
            page: 1,
            SizePage: 10,
            ReviewBlon: false,
            SetData: {
                state: "",
            },
        };
    },
    mounted() {
        this.GetUserInfo();
    },
    methods: {
        // 获取用户信息
        GetUserInfo() {
            this.$post("api/user/getUserInfo")
                .then(res => {
                    if (res.data.code == 1) {
                        const data = res.data.data;
                        this.professional_is_review = data.professional_is_review == 1;
                        this.company_is_review = data.company_is_review == 1;
                        this.project_is_review = data.project_is_review == 1;

                        if (this.project_is_review) {
                            this.i = 1;
                        } else if (this.professional_is_review) {
                            this.i = 2;
                        } else if (this.company_is_review) {
                            this.i = 3;
                        }
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
        },
        ToggleNav(i) {
            this.i = i;
            this.page = 1;
        },
        Query(t) {
            this.$refs[t].getData();
        },
        LockInfo(row) {
            this.$post("api/user/myJudgeDetails", {
                type: this.i,
                ids: row.id,
            }).then(res => {
                if (res.data.code == 1) {
                    this.ReviewBlon = !this.ReviewBlon;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        SetState(row) {
            this.$post("api/user/examine", {
                type: this.i,
                ids: row.id,
                status: 0,
            }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success(res.data.msg);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        ReviewSuc() {
            this.LockInfo();
        },
        SizeChange(val) {
            this.SizePage = val;
            this.getData();
        },
        PageChange(val) {
            this.page = val;
            this.getData();
        },
    },
};
</script>
<style scoped>
.ColorBlue {
    background-color: #027cfb;
    color: #fff;
}

.custom-text-size {
    font-size: 16px;
}

.Search {
    display: flex;
    align-items: center;
}

.SearchWid {
    width: 200px;
    margin-right: 10px;
}

.OrderTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 2px solid #ddd;
    position: relative;
    margin-bottom: 20px;
}

.Nav {
    flex: 1;
    display: flex;
    align-items: center;
}

.NavItem {
    font-size: 16px;
    padding: 15px 20px;
    text-align: center;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    position: relative;
}

.NavItem.Act {
    color: #e69d26;
    /* font-weight: 600; */
}

.NavItem.Act::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background: #e69d26;
    bottom: -2px;
    left: 0;
}

.NavMsg {
    color: #666;
    font-size: 16px;
}

.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.CommDig {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
}

.DigItem {
    display: flex;
    align-items: baseline;
    margin-bottom: 20px;
}

.DigItem .DigTit {
    font-size: 16px;
    color: #000000;
    margin-right: 20px;
    width: 50px;
}

.DigItem input,
.DigItem textarea {
    border-radius: 10px;
    border: solid 1px #e1e1e1;
    padding: 15px;
    flex: 1;
}

.DigItem .DigSelect {
    width: 280px;
    margin: 0;
}

.DigBtns {
    display: flex;
    align-items: center;
    justify-content: center;
}

.DigBtns .Btn {
    background-color: #f6faff;
    border-radius: 10px;
    border: solid 1px #d6e5ff;
    font-size: 16px;
    color: #2354f4;
    padding: 10px 40px;
    cursor: pointer;
}

.DigBtns .Btn:hover {
    box-shadow: 0 0 10px #b6d0ed;
}

.DigBtns .Btn.Blue {
    background-color: #027cfb;
    color: #fff;
    margin-left: 20px;
}

.LockImg {
    width: 40px;
    height: 40px;
}

@media only screen and (max-width: 550px) {}
</style>